export type AvailabilityEmptyMessageKey =
  | 'booking.step_2.shop_closed'
  | 'booking.step_2.no_slots'

export function availabilityEmptyMessageKey(
  businessClosed: boolean
): AvailabilityEmptyMessageKey {
  return businessClosed
    ? 'booking.step_2.shop_closed'
    : 'booking.step_2.no_slots'
}
